// Seções colapsáveis do painel (home enxuta): o gestor liga só o que quer ver; a escolha
// persiste em localStorage. Função pura — parsing defensivo de storage não vive inline no
// componente sem teste.

export const DASHBOARD_SECTION_IDS = [
  'vendas',
  'financeiro',
  'integracoes',
  'conferencia',
] as const;

export type DashboardSectionId = (typeof DASHBOARD_SECTION_IDS)[number];

// Catálogo saiu: produtos recentes e catálogo viraram a linha de anúncios e produtos das Conexões
// (seção Integrações). Um 'catalogo' guardado no navegador é descartado ao restaurar.
// Default: Vendas + Financeiro — o que o gestor olha todo dia (pendências e resultado).
export const DEFAULT_DASHBOARD_SECTIONS: DashboardSectionId[] = ['vendas', 'financeiro'];

/**
 * Restaura as seções visíveis persistidas. Lixo (JSON inválido, não-array) volta o default;
 * ids desconhecidos são filtrados. Array vazio VÁLIDO é respeitado — usuário que fechou tudo
 * de propósito reabre a home só com o essencial.
 */
export function restoreDashboardSections(raw: string | null): DashboardSectionId[] {
  if (!raw) return [...DEFAULT_DASHBOARD_SECTIONS];
  try {
    const parsed = JSON.parse(raw);
    if (!Array.isArray(parsed)) return [...DEFAULT_DASHBOARD_SECTIONS];
    // Ordem canônica (não a ordem em que foi salvo) — mesma normalização do toggle.
    return DASHBOARD_SECTION_IDS.filter((id) => parsed.includes(id));
  } catch {
    return [...DEFAULT_DASHBOARD_SECTIONS];
  }
}

/** Liga/desliga uma seção preservando a ordem canônica de DASHBOARD_SECTION_IDS. */
export function toggleDashboardSection(
  current: DashboardSectionId[],
  id: DashboardSectionId,
): DashboardSectionId[] {
  const next = current.includes(id) ? current.filter((s) => s !== id) : [...current, id];
  return DASHBOARD_SECTION_IDS.filter((s) => next.includes(s));
}
